import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataExternalApi } from '@onefootprint/request-types/dashboard';
import { CodeBlock, Tag, TextInput } from '@onefootprint/ui';
import startCase from 'lodash/startCase';
import { useTranslation } from 'react-i18next';
import CollapsibleSection from '@/components/playbook-builder/components/collapsible-section';
export type ConfigurationSectionProps = {
  node: {
    id: string;
    data: ApiNodeDataExternalApi;
  };
  isCollapsible?: boolean;
};
const ConfigurationSection = t0 => {
  const $ = _c(5);
  const {
    node,
    isCollapsible: t1
  } = t0;
  const isCollapsible = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "externalApi"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t2);
  let t3;
  if ($[1] !== isCollapsible || $[2] !== node || $[3] !== t) {
    t3 = isCollapsible ? <CollapsibleSection title={t(_temp)} className="p-4"><ConfigurationSectionContent node={node} /></CollapsibleSection> : <div className="border border-solid border-tertiary rounded-md"><div className="py-3 px-4 border-b border-solid border-tertiary"><h3 className="text-label-2 text-primary">{t(_temp2)}</h3></div><div className="py-4 px-4"><ConfigurationSectionContent node={node} /></div></div>;
    $[1] = isCollapsible;
    $[2] = node;
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
const ConfigurationSectionContent = t0 => {
  const $ = _c(27);
  const {
    node
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "externalApi"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const source = node.data.source;
  let t2;
  if ($[1] !== source) {
    t2 = typeof source === "object" && "vendorIntegration" in source ? source.vendorIntegration : {};
    $[1] = source;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    kind,
    useMockData
  } = t2;
  let t3;
  bb0: {
    const raw = node.data.config.body;
    if (!raw) {
      t3 = undefined;
      break bb0;
    }
    try {
      let t4;
      if ($[3] !== raw) {
        t4 = JSON.stringify(JSON.parse(raw), null, 2);
        $[3] = raw;
        $[4] = t4;
      } else {
        t4 = $[4];
      }
      t3 = t4;
    } catch {
      t3 = raw;
    }
  }
  const prettyBody = t3;
  const t4 = node.data.name;
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp3);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t(_temp4);
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== node.data.name || $[10] !== t5 || $[11] !== t6) {
    t7 = <TextInput disabled={true} value={t4} label={t5} placeholder={t6} />;
    $[9] = node.data.name;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== kind || $[14] !== t) {
    t8 = kind && <div className="flex flex-col gap-1"><span className="text-label-3 text-tertiary">{t(_temp5)}</span><Tag>{startCase(kind)}</Tag></div>;
    $[13] = kind;
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== prettyBody || $[17] !== t) {
    t9 = prettyBody && <div className="flex flex-col gap-1"><span className="text-label-3 text-tertiary">{t(_temp6)}</span><CodeBlock language="json" hideHeader={true} showLineNumbers={true} backgroundColor="secondary">{prettyBody}</CodeBlock></div>;
    $[16] = prettyBody;
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t || $[20] !== useMockData) {
    t10 = useMockData && <div className="flex flex-col gap-1"><span className="text-label-3 text-tertiary">{t(_temp7)}</span><CodeBlock language="json" hideHeader={true} showLineNumbers={true} backgroundColor="secondary">{useMockData}</CodeBlock></div>;
    $[19] = t;
    $[20] = useMockData;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t11 = <div className="flex flex-col gap-4 w-full">{t7}{t8}{t9}{t10}</div>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export default ConfigurationSection;
function _temp($) {
  return $.configuration;
}
function _temp2($_0) {
  return $_0.configuration;
}
function _temp3($) {
  return $.nodeName.label;
}
function _temp4($_0) {
  return $_0.nodeName.placeholder;
}
function _temp5($_1) {
  return $_1.vendorIntegration.integration;
}
function _temp6($_2) {
  return $_2.vendorIntegration.inputs;
}
function _temp7($_3) {
  return $_3.vendorIntegration.useMock;
}